import { toast } from "sonner";

export async function createTimeValue(timeValueData) {
    const token = sessionStorage.getItem('token'); // Retrieve the JWT token from session storage
    const headers = {
        'Authorization': `Bearer ${token}`, // Pass the token in the Authorization header
        'Content-Type': 'application/json'
    };
    const postUrl = `${process.env.REACT_APP_API_URL}/admin/profesor/valorhora/crear`;

    try {
        const postResponse = await fetch(postUrl, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(timeValueData) // Convert the time value data to JSON
        });

        const contentType = postResponse.headers.get('content-type');
        const responseText = await postResponse.text(); // Read the response as text

        if (!postResponse.ok) {
            console.error('Server responded with:', responseText);
            throw new Error('Failed to create time value');
        }

        if (contentType && contentType.includes('application/json')) {
            toast.success("Nómina creada exitosamente");
            return JSON.parse(responseText); // Attempt to parse the response as JSON
        } else {
            console.log('Response is not JSON:', responseText);
            toast.success("Nómina creada exitosamente");
            return { message: responseText }; // Return the response text as a message
        }

    } catch (error) {
        toast.error("Error al crear la nómina: " + error.message);
        throw new Error(`Failed to create time value: ${error.message}`);
    }
}